module.exports = __webpack_public_path__ + "img/scene4-2.b611bbf8.jpg";